export const PORTFOLIO_360 = 'Portfolio 360';
export const PORTFOLIO_360_APP_NAME = 'appPowerBI';
export const PORTFOLIO_360_ID = 'powerBI';
